type DetailsRecord = Record<string, unknown>;

const stripWrappingQuotes = (raw: string): string =>
  raw.startsWith('"') && raw.endsWith('"') ? raw.substring(1, raw.length - 1) : raw;

const toRecord = (parsed: unknown): DetailsRecord => {
  if (!parsed || typeof parsed !== 'object') return {};
  if (!Array.isArray(parsed)) return parsed as DetailsRecord;
  return parsed.reduce<DetailsRecord>(
    (merged, item: unknown) =>
      item && typeof item === 'object' && !Array.isArray(item)
        ? { ...merged, ...(item as DetailsRecord) }
        : merged,
    {},
  );
};

const tryParse = (raw: string): unknown => {
  try {
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
};

export const parseNotificationExtraDetails = (raw: string | undefined): DetailsRecord => {
  if (!raw) return {};
  const unquoted = stripWrappingQuotes(raw);
  const parsed = tryParse(unquoted.replace(/\\(.)/g, '$1')) ?? tryParse(unquoted);
  return toRecord(parsed);
};
